module.exports = __webpack_public_path__ + "static/img/cont4.68ea68d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont4.jpg
// module id = biFR
// module chunks = 0